<template>
   <element-loading :active="loading" class="spinner__cover">
     <div class="shadow-sm rounded-circle spinner__container">
       <img :src="icon" :width="ancho" :height="alto" />
       <div class="loader">Loading...</div>
     </div>
   </element-loading>
 </template>

<script>
import icon from "./../../../public/img/latino_loader.svg";

export default {
  name: "loading",
  data() {
    return {
      icon,
      ancho: "114px",
      alto: "114px",
    };
  },

  computed: {
    loading() {
      return this.$store.getters.toggleLoading;
    },
  },
};
</script>

<style lang="scss" scope="">
.spinner__cover {
  background-color: rgba(0, 58, 113, 0.692) !important;
  backdrop-filter: blur(3px);
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh !important;
}
.spinner__container {
  position: relative;
  img {
    position: absolute;
    top: -10px;
    left: -7px;
  }
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.5em solid #003b71;
  border-right: 0.5em solid #003b71;
  border-bottom: 0.5em solid #003b71;
  border-left: 0.5em solid white;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>